// import React, { useState, useEffect } from 'react';
// import { getTestimonials, createTestimonial, updateTestimonial, deleteTestimonial } from '../utils/api';
// import toast from 'react-hot-toast';

// const initForm = { name: '', position: '', company: '', content: '', rating: 5, isPublished: true, order: 0 };

// export default function TestimonialsPage() {
//   const [testimonials, setTestimonials] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [modal, setModal] = useState(null); // null | 'new' | id
//   const [form, setForm] = useState(initForm);
//   const [saving, setSaving] = useState(false);

//   const fetch = () => {
//     setLoading(true);
//     getTestimonials().then(r => setTestimonials(r.data.data)).catch(() => {}).finally(() => setLoading(false));
//   };

//   useEffect(() => { fetch(); }, []);

//   const openNew = () => { setForm(initForm); setModal('new'); };
//   const openEdit = (t) => {
//     setForm({ name: t.name, position: t.position || '', company: t.company || '', content: t.content, rating: t.rating, isPublished: t.isPublished, order: t.order || 0 });
//     setModal(t._id);
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     if (!form.name || !form.content) { toast.error('Name and content required'); return; }
//     setSaving(true);
//     try {
//       if (modal === 'new') await createTestimonial(form);
//       else await updateTestimonial(modal, form);
//       toast.success(modal === 'new' ? 'Testimonial added' : 'Testimonial updated');
//       setModal(null);
//       fetch();
//     } catch { toast.error('Save failed'); }
//     finally { setSaving(false); }
//   };

//   const handleDelete = async (id, name) => {
//     if (!window.confirm(`Delete testimonial from "${name}"?`)) return;
//     try {
//       await deleteTestimonial(id);
//       toast.success('Deleted');
//       fetch();
//     } catch { toast.error('Failed'); }
//   };

//   return (
//     <div className="space-y-5">
//       <div className="flex items-center justify-between">
//         <div>
//           <h1 className="font-display text-xl font-semibold text-surface-100">Testimonials</h1>
//           <p className="text-surface-500 text-sm mt-0.5">{testimonials.length} testimonials</p>
//         </div>
//         <button onClick={openNew} className="btn-primary">+ Add Testimonial</button>
//       </div>

//       {loading ? (
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {[...Array(4)].map((_, i) => <div key={i} className="card h-40 animate-pulse" />)}
//         </div>
//       ) : testimonials.length === 0 ? (
//         <div className="card p-12 text-center text-surface-600">No testimonials yet. Add your first one!</div>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {testimonials.map(t => (
//             <div key={t._id} className="card p-5 space-y-3">
//               <div className="flex items-start justify-between gap-2">
//                 <div>
//                   <div className="flex gap-0.5 mb-1">{[...Array(t.rating)].map((_, i) => <span key={i} className="text-brand-400 text-sm">★</span>)}</div>
//                   <p className="text-surface-200 font-medium text-sm">{t.name}</p>
//                   <p className="text-surface-500 text-xs">{t.position}{t.company ? `, ${t.company}` : ''}</p>
//                 </div>
//                 <span className={`text-xs px-2 py-0.5 rounded-full flex-shrink-0 ${t.isPublished ? 'bg-green-500/15 text-green-400' : 'bg-surface-700 text-surface-500'}`}>
//                   {t.isPublished ? 'Live' : 'Hidden'}
//                 </span>
//               </div>
//               <p className="text-surface-400 text-sm leading-relaxed line-clamp-3">"{t.content}"</p>
//               <div className="flex gap-2 pt-1">
//                 <button onClick={() => openEdit(t)} className="btn-secondary py-1 px-3 text-xs">Edit</button>
//                 <button onClick={() => handleDelete(t._id, t.name)} className="text-red-500 hover:text-red-400 text-xs transition-colors px-2">Delete</button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Modal */}
//       {modal !== null && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-surface-900/80 backdrop-blur-sm">
//           <div className="bg-surface-800 border border-surface-700 rounded-lg w-full max-w-lg p-6">
//             <div className="flex items-center justify-between mb-5">
//               <h2 className="font-display font-semibold text-surface-100">{modal === 'new' ? 'Add Testimonial' : 'Edit Testimonial'}</h2>
//               <button onClick={() => setModal(null)} className="text-surface-500 hover:text-surface-300 text-xl">✕</button>
//             </div>
//             <form onSubmit={handleSave} className="space-y-4">
//               <div className="grid grid-cols-2 gap-4">
//                 <div>
//                   <label className="label">Name *</label>
//                   <input name="name" value={form.name} onChange={handleChange} className="input" placeholder="Client name" required />
//                 </div>
//                 <div>
//                   <label className="label">Rating</label>
//                   <select name="rating" value={form.rating} onChange={handleChange} className="input">
//                     {[5,4,3,2,1].map(r => <option key={r} value={r}>{r} ★</option>)}
//                   </select>
//                 </div>
//               </div>
//               <div className="grid grid-cols-2 gap-4">
//                 <div>
//                   <label className="label">Position</label>
//                   <input name="position" value={form.position} onChange={handleChange} className="input" placeholder="e.g. Homeowner" />
//                 </div>
//                 <div>
//                   <label className="label">Company / City</label>
//                   <input name="company" value={form.company} onChange={handleChange} className="input" placeholder="e.g. Ahmedabad" />
//                 </div>
//               </div>
//               <div>
//                 <label className="label">Testimonial Content *</label>
//                 <textarea name="content" value={form.content} onChange={handleChange} className="input resize-none" rows={4} placeholder="What did they say…" required />
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input type="checkbox" name="isPublished" checked={form.isPublished} onChange={handleChange} className="accent-brand-400 w-4 h-4" />
//                   <span className="text-surface-300 text-sm">Published</span>
//                 </label>
//                 <div className="flex items-center gap-2">
//                   <label className="label mb-0">Order</label>
//                   <input type="number" name="order" value={form.order} onChange={handleChange} className="input w-20 py-1" min={0} />
//                 </div>
//               </div>
//               <div className="flex gap-3 pt-2">
//                 <button type="submit" disabled={saving} className="btn-primary flex-1">{saving ? 'Saving…' : 'Save'}</button>
//                 <button type="button" onClick={() => setModal(null)} className="btn-secondary flex-1">Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Plus, Edit, Trash2, Star } from 'lucide-react';
import { getAdminTestimonials, createTestimonial, updateTestimonial, deleteTestimonial } from '../utils/api';
import toast from 'react-hot-toast';
import ConfirmModal from '../components/ConfirmModal';

const emptyForm = { client_name: '', client_title: '', client_company: '', content: '', rating: 5, is_featured: false, is_active: true, sort_order: 0 };

function TestimonialModal({ testimonial, onSave, onClose }) {
  const [form, setForm] = useState(testimonial ? { ...testimonial } : emptyForm);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.client_name.trim() || !form.content.trim()) { toast.error('Name and content required'); return; }
    setSaving(true);
    try { await onSave(form, testimonial?.id); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-lg bg-surface-800 border border-white/10 rounded-xl overflow-hidden max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-5 border-b border-white/8 sticky top-0 bg-surface-800">
          <h3 className="font-semibold text-white">{testimonial ? 'Edit Testimonial' : 'Add Testimonial'}</h3>
          <button onClick={onClose} className="btn-ghost p-1.5 text-lg">×</button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Client Name *</label>
              <input name="client_name" value={form.client_name} onChange={handleChange} placeholder="Full name" className="input" />
            </div>
            <div>
              <label className="label">Title/Role</label>
              <input name="client_title" value={form.client_title || ''} onChange={handleChange} placeholder="e.g. CEO" className="input" />
            </div>
          </div>
          <div>
            <label className="label">Company</label>
            <input name="client_company" value={form.client_company || ''} onChange={handleChange} placeholder="Company name" className="input" />
          </div>
          <div>
            <label className="label">Testimonial Content *</label>
            <textarea name="content" value={form.content} onChange={handleChange} rows={4} placeholder="Client's testimonial..." className="input resize-none" />
          </div>
          <div>
            <label className="label">Rating</label>
            <div className="flex gap-1">
              {[1,2,3,4,5].map(r => (
                <button key={r} type="button" onClick={() => setForm(f => ({ ...f, rating: r }))}>
                  <Star size={20} className={r <= form.rating ? 'text-primary-400 fill-primary-400' : 'text-white/20'} />
                </button>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-5">
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" name="is_featured" checked={form.is_featured} onChange={handleChange} className="w-4 h-4 accent-primary-500" />
              <span className="text-sm text-white/70">Featured</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" name="is_active" checked={form.is_active} onChange={handleChange} className="w-4 h-4 accent-primary-500" />
              <span className="text-sm text-white/70">Active</span>
            </label>
          </div>
          <div className="flex gap-2 pt-2">
            <button type="submit" disabled={saving} className="btn-primary flex-1 justify-center">
              {saving ? 'Saving...' : (testimonial ? 'Update' : 'Create')}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function TestimonialsPage() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(undefined);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    setLoading(true);
    try {
      const res = await getAdminTestimonials();
      setTestimonials(res.data.data || []);
    } finally { setLoading(false); }
  };

  const handleSave = async (form, id) => {
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v === true ? '1' : v === false ? '0' : v ?? ''));
      if (id) {
        fd.append('_method', 'PUT');
        const res = await updateTestimonial(id, fd);
        setTestimonials(prev => prev.map(t => t.id === id ? res.data.data : t));
        toast.success('Testimonial updated');
      } else {
        const res = await createTestimonial(fd);
        setTestimonials(prev => [...prev, res.data.data]);
        toast.success('Testimonial created');
      }
      setModal(undefined);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save');
    }
  };

  const handleDelete = async () => {
    try {
      await deleteTestimonial(deleteId);
      setTestimonials(prev => prev.filter(t => t.id !== deleteId));
      toast.success('Testimonial deleted');
      setDeleteId(null);
    } catch { toast.error('Failed to delete'); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-semibold text-white">Testimonials</h1>
          <p className="text-white/40 text-sm mt-0.5">{testimonials.length} testimonials</p>
        </div>
        <button onClick={() => setModal(null)} className="btn-primary"><Plus size={15} /> Add Testimonial</button>
      </div>

      {loading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(3)].map((_, i) => <div key={i} className="card p-5"><div className="skeleton h-16 w-16 rounded-full mb-3" /><div className="skeleton h-3 w-full rounded mb-2" /><div className="skeleton h-3 w-2/3 rounded" /></div>)}
        </div>
      ) : testimonials.length === 0 ? (
        <div className="card p-12 text-center">
          <Star size={32} className="mx-auto mb-3 text-white/10" />
          <p className="text-white/30 text-sm mb-4">No testimonials yet</p>
          <button onClick={() => setModal(null)} className="btn-primary mx-auto"><Plus size={14} /> Add Testimonial</button>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map(t => (
            <div key={t.id} className="card p-5 group relative">
              <div className="absolute top-3 right-3 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <button onClick={() => setModal(t)} className="btn-ghost p-1.5"><Edit size={12} /></button>
                <button onClick={() => setDeleteId(t.id)} className="btn-ghost p-1.5 text-red-400/60 hover:text-red-400 hover:bg-red-500/10"><Trash2 size={12} /></button>
              </div>
              <div className="flex gap-1 mb-3">
                {[...Array(5)].map((_, i) => <Star key={i} size={13} className={i < t.rating ? 'text-primary-400 fill-primary-400' : 'text-white/15'} />)}
              </div>
              <p className="text-white/60 text-sm italic leading-relaxed mb-4 line-clamp-3">"{t.content}"</p>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 bg-primary-500/10 rounded-full flex items-center justify-center text-primary-400 font-semibold text-sm">
                  {t.client_name[0]}
                </div>
                <div>
                  <div className="text-sm font-medium text-white">{t.client_name}</div>
                  <div className="text-xs text-white/30">{[t.client_title, t.client_company].filter(Boolean).join(', ')}</div>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-3">
                {t.is_featured && <span className="badge bg-primary-500/10 text-primary-400 text-[10px]">Featured</span>}
                <span className={`w-1.5 h-1.5 rounded-full ${t.is_active ? 'bg-green-400' : 'bg-white/20'}`} />
                <span className="text-white/30 text-xs">{t.is_active ? 'Active' : 'Inactive'}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal !== undefined && <TestimonialModal testimonial={modal} onSave={handleSave} onClose={() => setModal(undefined)} />}
      <ConfirmModal open={!!deleteId} title="Delete Testimonial" message="Delete this testimonial?" onConfirm={handleDelete} onCancel={() => setDeleteId(null)} danger />
    </div>
  );
}